import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/editor/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Home from "@/pages/public/Home";
import EmotionalSignalLanding from "@/pages/public/EmotionalSignalLanding";
import ESHome from "@/pages/public/ESHome";
import PublicPage from "@/pages/public/PublicPage";
import Dashboard from "@/pages/editor/Dashboard";
import PageEditor from "@/pages/editor/PageEditor";
import MediaLibrary from "@/pages/editor/MediaLibrary";
import SettingsPage from "@/pages/editor/SettingsPage";
import Messages from "@/pages/editor/Messages";
import AdminsPage from "@/pages/editor/AdminsPage";
import Preview from "@/pages/editor/Preview";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback synchronously before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<ESHome />} />
      <Route path="/home-cms" element={<Home />} />
      <Route path="/p/:slug" element={<PublicPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/preview/:id" element={<ProtectedRoute><Preview /></ProtectedRoute>} />
      <Route path="/editor" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/editor/pages/:id" element={<ProtectedRoute><PageEditor /></ProtectedRoute>} />
      <Route path="/editor/media" element={<ProtectedRoute><MediaLibrary /></ProtectedRoute>} />
      <Route path="/editor/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/editor/admins" element={<ProtectedRoute><AdminsPage /></ProtectedRoute>} />
      <Route path="/editor/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
